/* eslint-disable no-undef */
import { API_BASE_URL } from '../../../config'
import { Feature, Source } from './Map.types'
/**
 * transformTileRequest
 */
export const transformTileRequest = (url: string, resourceType?: string) => {
  // Log all tile requests to diagnose authentication issues

  try {
    const accessToken = localStorage.getItem('jwt')
    const headers = { Authorization: `Bearer ${accessToken}` }

    if (resourceType && url.startsWith(API_BASE_URL as string)) {
      return { url, headers }
    }
  } catch (error) {
    console.error('[transformTileRequest] ERROR:', error)
  }

  // Always return a valid RequestParameters object
  return { url }
}

// Helper function to get feature from map event
export const getEventFeature = (
  e: mapboxgl.MapMouseEvent
): Feature | undefined => {
  if (!e.features || e.features.length === 0) return undefined
  const feature = e.features[0]

  return {
    ...feature,
    x: e.point.x,
    y: e.point.y,
  } as Feature
}

// Helper function to add sources to map
export const addSourcesToMap = (sources: Source[], map: mapboxgl.Map) => {
  sources.forEach((source) => {
    if (!map.getSource(source.id)) {
      const { layers, ...sourceConfig } = source
      map.addSource(source.id, sourceConfig as any)

      layers.forEach((layer) => {
        if (!map.getLayer(layer.id)) {
          map.addLayer({
            ...layer,
            source: layer.source || source.id,
          } as any)
        }
      })
    }
  })
}

// Helper function to remove sources from map
export const removeSources = (sources: Source[], map: mapboxgl.Map) => {
  sources.forEach((source) => {
    source.layers.forEach((layer) => {
      if (map.getLayer(layer.id)) {
        map.removeLayer(layer.id)
      }
    })
    if (map.getSource(source.id)) {
      map.removeSource(source.id)
    }
  })
}
